import React from 'react';
import { DemographicService } from '../services';

export const useDemographicService = () => React.useMemo(() => new DemographicService(), []);
